import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import { getTopCustomers } from '../../../selectors/reports';
import { Props } from './TopCustomersSection';

type StateProps = Pick<Props, 'data'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  data: getTopCustomers(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
